export const getAggregatedRowConfigs = ({
  i18n,
  showFilter,
  showWaterFall,
  showSearchRow,
  showAudienceRow,
  showPmaxRow,
  showNativeRow,
  showLinkedInRow,
  showDeletedRow,
  showUnknown,
  showOther,
  showOverall,
}) => {
  const configs = [
    {
      type: 'filtered',
      dataKey: '@ns.filtered.totals',
      text: i18n.getString(_TL_('Filtered total - {{number}} {{entity}}')),
      number: '@odata.count',
      ignore: !showFilter,
    },
    {
      type: 'waterfallFilter',
      dataKey: '@ns.filtered.totals',
      number: '@odata.count',
      ignore: !showWaterFall,
    },
    {
      type: 'search',
      dataKey: '@ns.search.non.deleted.totals',
      text: i18n.getString(_TL_('Search ads total')),
      helpId: 'pop_BA_CampaignGrids_SearchTotal',
      ignore: !showSearchRow,
    },
    {
      type: 'audience',
      dataKey: '@ns.audience.non.deleted.totals',
      text: i18n.getString(_TL_('Audience ads total')),
      helpId: 'pop_BA_CampaignGrids_AudienceTotal',
      ignore: !showAudienceRow,
    },
    {
      type: 'pmax',
      dataKey: '@ns.pmax.non.deleted.totals',
      text: i18n.getString(_TL_('Performance Max campaigns total')),
      ignore: !showPmaxRow,
    },
    {
      type: 'native',
      dataKey: '@ns.native.non.deleted.totals',
      text: i18n.getString(_TL_('Native total')),
      ignore: !showNativeRow,
    },
    {
      type: 'linkedin',
      dataKey: '@ns.linkedin.non.deleted.totals',
      text: i18n.getString(_TL_('LinkedIn campaigns total')),
      ignore: !showLinkedInRow,
    },
    {
      type: 'deleted',
      dataKey: '@ns.deleted.totals',
      text: i18n.getString(_TL_('Deleted items total')),
      helpId: 'pop_BA_CampaignGrids_DeletedTotal',
      ignore: !showDeletedRow,
    },
    {
      type: 'unknownDevices',
      dataKey: '@ns.unknown.totals',
      ignore: !showUnknown,
    },
    {
      type: 'other',
      dataKey: '@ns.other.totals',
      ignore: !showOther,
    },
    {
      type: 'overall',
      dataKey: '@ns.unfiltered.totals',
      text: i18n.getString(_TL_('Overall total - {{number}} {{entity}}')),
      number: '@ns.unfiltered.count',
      ignore: !showOverall,
    },
  ];

  return configs.filter(row => !row.ignore);
};

